"use client";

import { FC } from "react";

import { SignupFlowSlug } from "libs/state/src/lib/stores/signupFlow/constants";
import {
  SimpleProgressSteps,
} from "apps/website/components/feature/Navigation/SimpleProgressSteps/SimpleProgressSteps";
import {
  signupSteps,
} from "apps/website/components/feature/Navigation/SimpleProgressSteps/signupSteps";

interface ProgressStepsProps {
  hideProgressSteps: boolean | undefined;
  pathname: SignupFlowSlug;
}

export const ProgressSteps: FC<ProgressStepsProps> = ({
  hideProgressSteps = false,
  pathname,
}) => {
  if (hideProgressSteps) {
    return null;
  }

  return (
    <div className="flex justify-center flex-col w-full px-14 lg:px-0 mx-auto bg-white">
      <SimpleProgressSteps
        steps={signupSteps}
        currentSlug={pathname}
        hideLabels={true}
      />
    </div>
  );
};
